const token = state => state.token
const user = state => state.user
const isUserLoggedIn = state => state.isUserLoggedIn
const snack = state => state.snack
const type = state => state.type
const login = state => state.login

export { token, user, isUserLoggedIn, snack, type, login }
